import { Ref, forwardRef } from 'react';
import cx from 'classnames/bind';

import { Hint } from '../Hint';
import CheckIcon from '@/assets/check.svg';
import CrossIcon from '@/assets/cross.svg';
import type { IAnswer } from '@/types/answer';

import styles from './HintError.module.scss';

interface HintErrorProps {
  className?: string;
  selectedAnswer: string[];
  answers: IAnswer[];
}

const cn = cx.bind(styles);

const HintError = forwardRef(
  (
    { className, selectedAnswer, answers }: HintErrorProps,
    ref?: Ref<HTMLDivElement>,
  ) => {
    const rightAnswers = answers.filter(({ isRight }) => isRight);
    const isRightAnswer = (item: string) =>
      rightAnswers.some(({ text }) => text === item);

    return (
      <Hint ref={ref} className={cn('hint', className)}>
        На самом деле правильный ответ:{' '}
        {rightAnswers.map(({ text }) => text).join(', ')}
        <div className={cn('answers')}>
          <span className={cn('answers-title')}>Вы выбрали:</span>
          <ul className={cn('answers-list')}>
            {selectedAnswer.map((item) => (
              <li key={item} className={cn('answers-item')}>
                <div
                  className={cn(
                    'answers-icon-wrapper',
                    `${
                      !isRightAnswer(item) ? 'answers-icon-wrapper-error' : ''
                    }`,
                  )}
                >
                  <img
                    className={cn('answers-icon')}
                    src={isRightAnswer(item) ? CheckIcon : CrossIcon}
                    alt="Иконка"
                  />
                </div>
                {item}
              </li>
            ))}
          </ul>
        </div>
      </Hint>
    );
  },
);

export default HintError;
